import { motion } from "framer-motion";
import wipro from "../../assets/wipro.png";
import virtusa from "../../assets/virtusa.png";
import sunrise from "../../assets/sunrise.png";
import kpmg from "../../assets/KPMG.png";
import lt from "../../assets/LTIM-NS-dea59dc6.png";
import pega from "../../assets/pega.png";
import serivenow from "../../assets/servicenow.png";
import zenser from "../../assets/zensar.png";
import client_1 from "../../assets/boubyan-bank.png";
import client_2 from "../../assets/ust.png";
import hsbc from "../../assets/hsbc.png"
import ingbank from "../../assets/ing-bank.png"
const ROW_ONE = [
  { name: "Wipro", logo: wipro },
  { name: "Virtusa", logo: virtusa },
  { name: "Sunrise", logo: sunrise },
  { name: "KPMG", logo: kpmg },
  { name: "Boubyan Bank", logo: client_1 },
  { name: "Wipro", logo: wipro },
  { name: "Virtusa", logo: virtusa },
  { name: "Sunrise", logo: sunrise },
  { name: "KPMG", logo: kpmg },
  { name: "Boubyan Bank", logo: client_1 },
];

const ROW_TWO = [
  { name: "HSBC", logo: hsbc },
  { name: "ServiceNow", logo: serivenow },
  { name: "Zensar", logo: zenser },
  { name: "UST", logo: client_2 },
  { name: "LTIMindtree", logo: lt },
  { name: "ingbank", logo: ingbank },
  { name: "Pega Service", logo: pega },
 
];

function ClientLogo({ client, index }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{
        delay: index * 0.06,
        duration: 0.5,
      }}
      whileHover={{
        rotateX: 5,
        rotateY: -5,
        scale: 1,
      }}
      style={{
        transformPerspective: 800,
      }}
      className="group flex shrink-0 items-center justify-center"
    >
      <div className="relative flex h-20 w-[180px] items-center justify-center rounded-xl border border-black/[0.06] bg-white/60 px-6 shadow-[0_10px_30px_rgba(0,0,0,0.04)] backdrop-blur-md transition-all duration-300 group-hover:bg-white group-hover:shadow-[0_20px_40px_rgba(0,0,0,0.10)] sm:h-24 sm:w-[200px]">
        <img
          src={client.logo}
          alt={`${client.name} logo`}
          className="h-10 w-auto max-w-[150px] object-contain  transition-all duration-300 group-hover:scale-105 group-hover:opacity-100 group-hover:grayscale-0 sm:h-12 sm:max-w-[170px]"
        />
      </div>
    </motion.div>
  );
}

export default function HomeClients() {
  return (
    <section className="relative w-full overflow-hidden bg-[#ffffff] lg:py-24 md:py-16 py-10 text-[#000036]">
      <div className="relative z-10 mx-auto flex flex-col items-center lg:px-6 xl:w-4/5">
        <div className="mb-16 flex max-w-4xl flex-col items-center text-center md:mb-20">
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mb-4 inline-flex items-center gap-2 rounded-full  px-3.5 py-1.5 backdrop-blur-md"
          >
            <span className="text-[11px] font-bold uppercase tracking-[0.2em] px-6 lg:px-0 text-slate-700">
              Trusted Network
            </span>
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.08 }}
            className="font-display text-3xl sm:text-4xl md:text-5xl font-bold px-6 lg:px-0 tracking-tight text-slate-950 "
          >
            Trusted by the <span className="italic font-serif font-normal text-[#5dc9f0]">
             World’s Leading
            </span>{" "} organizations
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.15 }}
            className="mt-5 max-w-2xl text-base font-normal leading-relaxed px-6 lg:px-0 text-slate-600 sm:text-lg"
          >
            Innovative technology solutions across banking and financial
            services, insurance, healthcare, and government sectors.
          </motion.p>
        </div>
       
        <div className="relative w-full  space-y-8 sm:space-y-10">
          <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-20 bg-gradient-to-r from-[#ffffff] to-transparent sm:w-28" />
          <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-20 bg-gradient-to-l from-[#ffffff] to-transparent sm:w-28" />
          <div className="h-20 overflow-hidden sm:h-24">
            <motion.div
              animate={{ x: ["0%", "-50%"] }}
              transition={{
                repeat: Infinity,
                ease: "linear",
                duration: 40,
              }}
              className="flex w-max items-center gap-5 whitespace-nowrap sm:gap-7"
            >
              {[...ROW_ONE, ...ROW_ONE].map((client, idx) => (
                <ClientLogo
                  key={`${client.name}-${idx}`}
                  client={client}
                  index={idx}
                />
              ))}
            </motion.div>
          </div>
          <div className="h-20 overflow-hidden sm:h-24">
            <motion.div
              animate={{ x: ["-50%", "0%"] }}
              transition={{
                repeat: Infinity,
                ease: "linear",
                duration: 30,
              }}
              className="flex w-max items-center gap-5 whitespace-nowrap sm:gap-7"
            >
              {[...ROW_TWO, ...ROW_TWO].map((client, idx) => (
                <ClientLogo
                  key={`${client.name}-${idx}`}
                  client={client}
                  index={idx + ROW_ONE.length}
                />
              ))}
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
